import React from 'react'

import {Route, Switch, Redirect} from 'react-router-dom'
import css from './Root.css'

import LoginRoutes from '$src/login/routes'
import ConsentRoutes from '$src/consent/routes'

export default (
  <div className={css.routes}>
    <Switch>
      {[
        <Route
          key="root1"
          exact
          path="/"
          component={props => (
            <Redirect to={`/login${props.location.search}`} />
          )}
        />,
        ...LoginRoutes,
        ...ConsentRoutes,
      ]}
    </Switch>
  </div>
)



// WEBPACK FOOTER //
// ./src/root/components/RootRoutes.js